var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"no-found"},[_c('img',{attrs:{"src":require("../assets/img/404.png"),"alt":""}}),_vm._v(" "),_c('p',[_vm._v("你可能迷路了，将在 "+_vm._s(_vm.time)+" 秒后 "),_c('a',{staticClass:"el-button el-button--text",attrs:{"href":"#/","title":"返回首页"}},[_vm._v("返回首页")])])])
}
var staticRenderFns = []

export { render, staticRenderFns }